import { useEffect, useState, useCallback, useRef } from 'react';
import { useTelegram } from './useTelegram';
import moment from 'moment-jalaali';
import config from '../../config';
import api from '../api';

// مخزن سراسری رم
let globalRequestCache = {};

export const clearBusinessLoginCache = (chatId = null, collebrationId = null) => {
    if (chatId !== null && collebrationId !== null) {
        delete globalRequestCache[`${chatId}_${collebrationId}`];
    } else {
        globalRequestCache = {};
    }
};

export const updateBusinessLoginCache = (chatId, collebrationId = 0, newBusinessData = {}) => {
    if (!chatId) return;
    const cacheKey = `${chatId}_${collebrationId}`;
    if (globalRequestCache[cacheKey]?.data) {
        globalRequestCache[cacheKey].data = {
            ...globalRequestCache[cacheKey].data,
            data: {
                ...(globalRequestCache[cacheKey].data.data || {}),
                ...newBusinessData
            }
        };
    }
};

export const useBusinessLogin = (CollebrationId = 0) => {
    const [category, setCategory] = useState([]);
    const [data, setData] = useState([]);
    const [instagramTitle, setInstagramTitle] = useState(null);
    const [instagramUsername, setInstagramUsername] = useState(null);
    const [merchant_id, setMerchantId] = useState(null);
    const [imagePath, setImagePath] = useState(null);
    const [imageSignature, setImageSignature] = useState(null);
    const [businessId, setBusinessId] = useState(0);
    const [message, setMessage] = useState(null);
    const [instagramConfirmed, setInstagramConfirmed] = useState(false);
    const [permissionCollebration, setPermissionCollebration] = useState(null);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [days, setDays] = useState(0);
    const [isCreditValid, setIsCreditValid] = useState(false);

    const [isloading, setisLoading] = useState(true);
    const [login, setlogin] = useState(false);

    const { ChatId } = useTelegram();
    const isMounted = useRef(true);

    const handleSuccessData = useCallback((responseData) => {
        if (!isMounted.current) return;

        if (CollebrationId === 0) {
            if (responseData && responseData.success) {
                const resData = responseData.data || {};
                setData(resData);
                setCategory({ 
                    category_id: resData.category_id, 
                    category_title: resData.category?.title || resData.category_title 
                });
                setInstagramTitle(resData.title);
                setInstagramUsername(resData.instagram_username || resData.instagram_userName);
                setMerchantId(resData.merchant_id);
                setBusinessId(resData.id);
                setImagePath(resData.image_path);
                setImageSignature(resData.image_signature);
                setMessage(responseData.message || resData.message || null);
                setInstagramConfirmed(resData.instagram_confirmed == "0" || resData.instagram_confirmed ? false : true);

                if (resData.start_date) {
                    setStartDate({ date: resData.start_date, time: resData.start_date });
                } else {
                    setStartDate(null);
                }

                if (resData.end_date) {
                    setEndDate({ date: resData.end_date, time: resData.end_date });
                    const remainingDays = moment(resData.end_date).diff(moment(), 'days');
                    setDays(remainingDays > 0 ? remainingDays : 0);
                } else {
                    setEndDate(null);
                    setDays(0);
                }

                setIsCreditValid(Boolean(resData.is_credit_valid));
                setlogin(true);
            } else {
                setlogin(false);
                setBusinessId(0);
                setMessage(responseData?.message || null);
                setStartDate(null);
                setEndDate(null);
                setDays(0);
                setIsCreditValid(false);
                
                if (responseData?.data && !Array.isArray(responseData.data)) {
                    setData(responseData.data);
                } else {
                    setData(null);
                }
            }
        } else {
            if (responseData && responseData.success) {
                try {
                    setPermissionCollebration(JSON.parse(responseData.data.permission));
                } catch {
                    setPermissionCollebration(responseData.data.permission);
                }
                setBusinessId(responseData.data.id_business);
                setlogin(true);
            } else {
                setlogin(false);
                setBusinessId(0);
            }
        }
    }, [CollebrationId]);

    const fetchData = useCallback((forceFetch = false) => {
        // if (ChatId === null || ChatId === undefined) return;

        const cacheKey = `${ChatId}_${CollebrationId}`;

        if (forceFetch) {
            delete globalRequestCache[cacheKey];
        }

        // ۱. اگر دیتا از قبل با موفقیت کش شده بود، مستقیماً تحویل بده
        if (!forceFetch && globalRequestCache[cacheKey]?.data) {
            handleSuccessData(globalRequestCache[cacheKey].data);
            setisLoading(false);
            return;
        }

        // ۲. اگر همین ریکوئست هم‌اکنون در شبکه در جریان است، ریکوئست دوم نفرست و منتظر همان باش
        if (!forceFetch && globalRequestCache[cacheKey]?.promise) {
            setisLoading(true);
            globalRequestCache[cacheKey].promise
                .then((res) => {
                    handleSuccessData(res.data);
                })
                .catch(() => {
                    if (isMounted.current) setlogin(false);
                })
                .finally(() => {
                    if (isMounted.current) setisLoading(false);
                });
            return;
        }

        setisLoading(true);

        const requestPromise = (CollebrationId === 0)
            ? api.post(`business/find/user`)
            : api.post(`collebration/user/request`, { collebration_id: CollebrationId });

        // ثبت آنی پرامیس در کش قبل از رسیدن پاسخ
        globalRequestCache[cacheKey] = {
            promise: requestPromise,
            data: null
        };

        requestPromise
            .then((response) => {
                if (response.data && response.data.success) {
                    // فقط اگر فروشگاه معتبر داشت کش نگه‌داشته می‌شود
                    if (globalRequestCache[cacheKey]) {
                        globalRequestCache[cacheKey].data = response.data;
                        globalRequestCache[cacheKey].promise = null;
                    }
                } else {
                    // اگر فروشگاه نداشت، کش را آزاد می‌کنیم تا دفعه بعد درخواست تازه برود
                    delete globalRequestCache[cacheKey];
                }
                handleSuccessData(response.data);
            })
            .catch((err) => {
                console.error("Error in useBusinessLogin:", err);
                if (isMounted.current) setlogin(false);
                delete globalRequestCache[cacheKey];
            })
            .finally(() => {
                if (isMounted.current) setisLoading(false);
            });
    }, [ChatId, CollebrationId, handleSuccessData]);

    useEffect(() => {
        isMounted.current = true;
        
        // فقط یک بار در مونت کامپوننت فراخوانی می‌شود
        fetchData(false);

        const handleBusinessUpdate = () => {
            fetchData(true);
        };

        window.addEventListener('businessInfoUpdated', handleBusinessUpdate);

        return () => {
            isMounted.current = false;
            window.removeEventListener('businessInfoUpdated', handleBusinessUpdate);
        };
    }, [fetchData]);

    const refetch = useCallback(() => {
        return fetchData(true);
    }, [fetchData]);

    return {
        data,
        login,
        ChatId,
        businessId,
        isloading,
        category,
        instagramTitle,
        instagramUsername,
        message,
        merchant_id,
        imagePath,
        imageSignature,
        instagramConfirmed,
        permissionCollebration,
        startDate,
        endDate,
        days,
        is_credit_valid: isCreditValid,
        isCreditValid,
        refetch
    };
};
